module.exports = __webpack_public_path__ + "static/media/PL_understanding@2x.d6c942af.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/performanceLeader/PL_understanding@2x.png
// module id = 220
// module chunks = 0